/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Heading } from '@vaisala-rockhopper/components';
import './PhaseIndicator.scss';

export interface PhaseIndicatorProps {
  phase: number;
  active: boolean;
}

const PhaseIndicator = ({ phase, active }: PhaseIndicatorProps) => {
  return (
    <div className={`phase-indicator ${active ? 'active' : ''}`}>
      <Heading level={4}>{phase}</Heading>
    </div>
  );
};

export default PhaseIndicator;
